webpackJsonp([140389645284302],{

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/auto_insurance_info.08147a42.pdf";

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/insurance_information.ac8c3dcd.pdf";

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/intake_and_consent_to_treatment.7e6c6908.pdf";

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/patient-privacy-disclosure.f3e1ac8c.pdf";

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _intake_and_consent_to_treatment = __webpack_require__(318);
	
	var _intake_and_consent_to_treatment2 = _interopRequireDefault(_intake_and_consent_to_treatment);
	
	var _patientPrivacyDisclosure = __webpack_require__(319);
	
	var _patientPrivacyDisclosure2 = _interopRequireDefault(_patientPrivacyDisclosure);
	
	var _insurance_information = __webpack_require__(317);
	
	var _insurance_information2 = _interopRequireDefault(_insurance_information);
	
	var _auto_insurance_info = __webpack_require__(316);
	
	var _auto_insurance_info2 = _interopRequireDefault(_auto_insurance_info);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patientForms = function patientForms() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Patient Forms'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If possible, please read and complete these forms prior to your first appointment. If you are unable to bring these forms with you, I will provide them to you at the clinic. Please arrive 15-20 minutes early to ensure that you have enough time to fill them out before your treatment.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'a',
	        { href: _intake_and_consent_to_treatment2.default },
	        'Intake and Consent to Treatment'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'a',
	        { href: _patientPrivacyDisclosure2.default },
	        'Patient Privacy Disclosure'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'a',
	        { href: _insurance_information2.default },
	        'Insurance Information'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      'If you are paying through PIP (auto accidents), please complete ',
	      _react2.default.createElement(
	        'a',
	        { href: _auto_insurance_info2.default },
	        'this form'
	      ),
	      ' and bring it with your to your first session. If you are unable to open these documents,',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://get.adobe.com/reader/' },
	        ' click here'
	      ),
	      ' to download the free Adobe Reader.'
	    )
	  );
	};
	
	exports.default = patientForms;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-patient-forms-js-ef30a8dc4bab67c62f75.js